import { Directive, output } from '@angular/core';

@Directive({
  selector: 'input[type="file"][inputPreview]',
  standalone: false,
  host: {
    '(change)': 'getSrc($event)'
  }
})
export class InputPreview {
  readonly src=output<string|null>();

  constructor() { }

  getSrc(event: Event){
    const input=event.target as HTMLInputElement;

    if(input.files && input.files.length!==0){
      const reader=new FileReader();
      reader.onload=() => {
        this.src.emit(reader.result as string);
      }
      reader.readAsDataURL(input.files[0]);
    }
    else
      this.src.emit(null);
  }
}
